const DATA = [
  {
    id: 13,
    title:
      'A Method for Fast Validation and Repair of Tool Calling in Agentic Systems',
    authors:
      'Tathagata Chakraborti, Zidane Wright, Jungkoo Kang, and Kiran A Kate',
    year: '2025',
  },
  {
    id: 12,
    title:
      'A System and Method for Predictive Caching of Tool Responses in Agentic Systems',
    authors:
      'Tathagata Chakraborti, Kiran A Kate, Poulomi Ghosh, Yara Rizk, and Mayank Agarwal',
    year: '2025',
  },
  {
    id: 11,
    title: 'Plan visualization by disambiguation',
    authors:
      'Jungkoo Kang, Michael Katz, Shirin Sohrabi Araghi, and Tathagata Chakraborti',
    year: '2025',
  },
  {
    id: 10,
    title: 'Interfacing with planned operations of an aggregated assistant',
    authors:
      'Kristina Marie Brimijoin, Shubham Agarwal, Tathagata Chakraborti, Aalim Lakhani, and Scott Boag',
    year: '2024',
  },
  {
    id: 9,
    title: 'Multi-agent chatbot with multi-intent recognition',
    authors: 'Burak Aksar, Yara Rizk, and Tathagata Chakraborti',
    year: '2024',
  },
  {
    id: 8,
    title: 'Automated generation of workflows',
    authors:
      'Sarath Sreedharan, Tathagata Chakraborti, Vinod Muthusamy, Yara Rizk, and Yasaman Khazaeni',
    year: '2024',
  },
  {
    id: 7,
    title: 'Explaining natural-language-to-flow pipelines',
    authors:
      'Tathagata Chakraborti, Arunima Chaudhary, Michelle Brachman, Qian Pan, James Johnson, Yara Rizk, and Burak Aksar',
    year: '2023',
  },
  {
    id: 6,
    title: "Generating explanations for an aggregated assistant's actions",
    authors:
      'Sarath Sreedharan, Tathagata Chakraborti, Yara Rizk, Vinod Muthusamy, and Yasaman Khazaeni',
    year: '2023',
  },
  {
    id: 5,
    title: 'Automated personalization of a user experience',
    authors: 'Tathagata Chakraborti',
    year: '2023',
  },
  {
    id: 4,
    title:
      'System and method for the orchestration of plugins on the command line',
    authors:
      'Tathagata Chakraborti, Mayank Agarwal, Zhongshen Zeng, Yasaman Khazaeni, and Sohini Upadhyay',
    year: '2023',
  },
  {
    id: 3,
    title:
      'Flexible artificial intelligence agent infrastructure for adapting processing of a shell',
    authors:
      'Tathagata Chakraborti, Mayank Agarwal, Eli M Dow, Kartik Talamadupula, Kshitij Fadnis, Jorge J Barroso Carmona, and Borja Godoy',
    year: '2023',
  },
  {
    id: 2,
    title: 'Data augmented training of reinforcement learning software agent',
    authors:
      'Tathagata Chakraborti, Kartik Talamadupula, Kshitij P. Fadnis, Biplav Srivastava, and Murray Scott Campbell',
    year: '2023',
  },
  {
    id: 1,
    title: 'Business processes optimization using non-deterministic planning',
    authors:
      'Tathagata Chakraborti, Sarath Sreedharan, Shubham Agarwal, Yasaman Khazaeni, Yara Rizk, and Vatche Isahagian',
    year: '2022',
  },
];

export default DATA;
